module.exports = __webpack_public_path__ + "img/bg-icono-pdf.2fad3650.svg";